import getPublicUrl from '@/helpers/utils/routing/getPublicUrl'
import { PageProps } from '@/types'
import { toPathFactory } from '@/helpers/utils/routing/toPathFactories'

export const pageUrl =
  '/[locale]/fundraising-events/[slug]/manage/projects/[id]?page&query&category&organisation&bounds'
export const getPageUrl = toPathFactory(pageUrl, getPublicUrl.bind(null, true))
export type ProjectPreviewPageProps = PageProps<typeof pageUrl>
